import { BodyShapeOptionsType } from './types';

export const BODY_SHAPE_OPTIONS: BodyShapeOptionsType = [
  {
    id: 'slim',
    title: 'Slim',
  },
  {
    id: 'tone',
    title: 'Tone',
  },
  {
    id: 'muscular',
    title: 'Muscular',
  },
  {
    id: 'plus_size',
    title: 'Plus Size',
  },
];
